import api from "./api";
const svc = {
  listar:       (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/contas-pagar?${qs}`); },
  buscarPorId:  id     => api("GET",`/contas-pagar/${id}`),
  criar:        data   => api("POST","/contas-pagar",data),
  atualizar:    (id,data) => api("PUT",`/contas-pagar/${id}`,data),
  cancelar:     id     => api("PATCH",`/contas-pagar/${id}/cancelar`,{}),
  aprovar:      id     => api("PATCH",`/contas-pagar/${id}/aprovar`,{}),
  rejeitar:     (id,motivoRejeicao) => api("PATCH",`/contas-pagar/${id}/rejeitar`,{motivoRejeicao}),
  pagarParcela: (idParcela,data) => api("POST",`/contas-pagar/parcelas/${idParcela}/pagar`,data),
  relatorio:    (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/contas-pagar/relatorio?${qs}`); },
  atualizarVencidas: () => api("PATCH","/contas-pagar/atualizar-vencidas",{}),
  editarVencimentoParcela: (idParcela, dtVencimento) => api("PATCH", `/contas-pagar/parcelas/${idParcela}/vencimento`, {dtVencimento}),
};
export default svc;
